import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

export const useIsMobileView = () => {
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));
  return isMobileView;
};
